import { MediaContent, GetRelevantSourcesResponse } from '@goldcast/api/content';
import { getBroadcastBackgroundImageUrl } from '../utils';
import { PreviewImageSize } from '../constants';
import ProgressiveImage from '@/components/atoms/ProgressiveImage/ProgressiveImage';
import Icon from '@/components/atoms/Icon';

export default function SessionThumbnail({
  session,
  iconSize
}: {
  session: MediaContent | GetRelevantSourcesResponse;
  iconSize: number;
}) {
  return session.media_type === 'AUDIO' ? (
    <Icon
      name="IconHeadphones"
      size={iconSize}
      stroke={1.5}
      className="text-slate-700"
      data-testid="session-audio-icon"
    />
  ) : (
    <ProgressiveImage
      src={`${getBroadcastBackgroundImageUrl(session, PreviewImageSize.Large)}`}
      placeholderSrc={`${getBroadcastBackgroundImageUrl(session)}`}
    />
  );
}
